/**
 * PDD - Badge de remise unifié (cartes + fiche produit).
 *
 * Le badge de remise de l'app Regios est désactivé côté thème (champ
 * « badge description » vidé dans l'app embed Regios) : il écrasait des labels
 * existants et provoquait un double-rendu au chargement.
 *
 * Ici on garantit UN SEUL badge « -XX% » par produit, calculé sur les PRIX
 * AFFICHÉS (prix barré → prix final), donc cohérent avec ce que voit le client,
 * y compris quand une promo Shopify (compare_at) et une remise Regios se cumulent.
 * - S'il existe déjà un badge de pourcentage (badge natif du thème), on corrige
 *   son texte avec le total et on supprime les doublons éventuels.
 * - Sinon (remise Regios pure, sans badge natif), on ajoute le nôtre.
 *
 * On lit le DOM (pas l'API Regios) car le prix affiché peut différer du calcul
 * brut de l'API selon les variantes ; le badge doit refléter le prix montré.
 */
(function () {
  'use strict';

  var SCHEME = window.PDD_SALE_SCHEME || '';

  function makeBadge(text, extraClass) {
    var span = document.createElement('span');
    span.className = 'badge ' + (extraClass ? extraClass + ' ' : '') + 'color-' + SCHEME;
    span.dataset.pddDiscountBadge = '1';
    span.textContent = text;
    return span;
  }

  function parsePrice(text) {
    if (!text) return null;
    var m = text.replace(/\s/g, '').match(/([\d,\.]+)/);
    if (!m) return null;
    return parseFloat(m[1].replace(',', '.'));
  }

  function isPercentBadge(badge) {
    return /^-?\d+\s*%$/.test((badge.textContent || '').trim());
  }

  function syncBadge(priceEl, container, extraClass) {
    if (!priceEl || !container) return;

    // Produit marque `custom.show_discount = "non"` : aucun badge de pourcentage,
    // meme si une remise est affichee. Le Liquid n'en rend pas, on n'en ajoute pas,
    // et on retire ceux qu'une autre source (Regios) aurait pu injecter.
    if (container.dataset.pddNoDiscountBadge === '1') {
      [].slice.call(container.querySelectorAll('.badge'))
        .filter(isPercentBadge)
        .forEach(function (b) { b.remove(); });
      return;
    }

    var regularEl = priceEl.querySelector(
      '.price__sale .price-item--regular, .price-item--regular s, s.price-item--regular'
    );
    var saleEl = priceEl.querySelector('.price-item--sale');
    var regular = parsePrice(regularEl && regularEl.textContent);
    var sale = parsePrice(saleEl && saleEl.textContent);

    var pctBadges = [].slice.call(container.querySelectorAll('.badge')).filter(isPercentBadge);

    // Pas de remise affichée : on retire notre badge éventuel, on laisse le reste.
    if (!regular || !sale || sale >= regular) {
      pctBadges.forEach(function (b) { if (b.dataset.pddDiscountBadge) b.remove(); });
      return;
    }

    var text = '-' + Math.round((regular - sale) / regular * 100) + '%';

    if (pctBadges.length) {
      // Réutilise le premier badge de pourcentage (natif ou nôtre), supprime les doublons.
      if (pctBadges[0].textContent.trim() !== text) pctBadges[0].textContent = text;
      for (var i = 1; i < pctBadges.length; i++) pctBadges[i].remove();
    } else {
      container.appendChild(makeBadge(text, extraClass));
    }
  }

  function run() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      syncBadge(card.querySelector('.price'), card.querySelector('.card__badge'), null);
    });
    syncBadge(
      document.querySelector('.product__price .price'),
      document.querySelector('.product__badges'),
      'badge--save'
    );
  }

  function start() {
    run();
    // Throttle (et non debounce) : sur une page chargée, les mutations ne se
    // "calment" jamais et un debounce ferait traîner le badge. Le throttle relance
    // run() régulièrement pendant les mutations → le badge suit de près la remise
    // prix appliquée par Regios.
    var lastRun = 0;
    var timer = null;
    function schedule() {
      if (timer) return;
      var wait = Math.max(0, 100 - (Date.now() - lastRun));
      timer = setTimeout(function () {
        timer = null;
        lastRun = Date.now();
        run();
      }, wait);
    }
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
